/**
 * This component is the common favorite button component
 */

import globals from '../../common/globals';
import vxJuicerFeed from '../../common/vx-juicer-feed/vx-juicer-feed.vue';


export default {
  name: 'vx-campaign-connect',
  components: { vxJuicerFeed },
  props: {
  },
  mixins: [],
  data() {
    return {
      globals,
      socialIcons: {
        links: [
          {
            linkText: 'brawny/Facebook',
            linkTo: 'https://www.facebook.com/brawny',
            linkURL: globals.assetsPath + 'images/brawny/facebook.png',
          },
          {
            linkText: 'brawny/Instagram',
            linkTo: 'https://www.instagram.com/BrawnyBrand',
            linkURL: globals.assetsPath + 'images/brawny/instagram.png',
          },
          {
            linkText: 'brawny/Twitter',
            linkTo: 'https://twitter.com/Brawny',
            linkURL: globals.assetsPath + 'images/brawny/twitter.png',
          },
          {
            linkText: 'brawny/YouTube',
            linkTo: 'https://www.youtube.com/user/BrawnyTowels',
            linkURL: globals.assetsPath + 'images/brawny/youtube.png',
          },
        ],
      },
      juicerFeedData: { filter: null, gutter: '20', truncate: null, overlay: null, endDate: null, feedId: 'brawnybrand', columns: '4', dataPer: '4', interval: null, style: 'widget', startDate: null },
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-connect/vx-campaign-connect.js